import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, CheckCircle2 } from 'lucide-react';
const tomos = [{
  icon: '📘',
  title: 'TOMO 1 — Clásicos de Bodegón',
  desc: 'Milanesas, guisos, pastas, tartas y pollo. Los platos que te criaron, con instrucciones claras. 18 recetas + planificador semanal.'
}, {
  icon: '📗',
  title: 'TOMO 2 — Minutas Rápidas y Carnes',
  desc: 'Ninguna receta supera los 35 minutos. Para los días con poco tiempo y mucho hambre. 18 recetas + protocolo express del domingo.'
}, {
  icon: '📙',
  title: 'TOMO 3 — Pastas, Arroces y Legumbres',
  desc: 'Los ingredientes más económicos y versátiles de Argentina, convertidos en platos que sorprenden. 18 recetas + tabla de cocción maestra.'
}, {
  icon: '📕',
  title: 'TOMO 4 — Tartas, Empanadas y Pizzas',
  desc: 'Las reinas de la mesa argentina. Con masas, rellenos, técnicas y guía de freezado incluida. 18 recetas + masa universal.'
}, {
  icon: '📓',
  title: 'TOMO 5 — El Mes de Oro',
  desc: 'El sistema completo. Menú de 30 días cerrado, lista de compras mensual y rotación anual. 10 recetas especiales exclusivas.'
}];
const features = ['Paso a paso claro', 'Tiempos reales', 'Ingredientes del súper de barrio', 'Planificador semanal', 'Tips de freezado', '70% clásicos / 30% saludables'];
export const TomosSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 px-4 bg-black" data-id="element-263">
      <div className="max-w-3xl mx-auto" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-265">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-266">
            🍽️ LA SOLUCIÓN COMPLETA
          </h2>
          <p className="text-xl md:text-2xl text-orange-500 font-bold" data-id="element-267">
            5 Tomos. Una cocina organizada para siempre.
          </p>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-268">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="border-2 border-orange-500 rounded-xl overflow-hidden bg-gray-900" data-id="element-269">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between bg-black hover:bg-gray-900 transition-colors text-left" data-id="element-270">
                <div className="flex items-center gap-3" data-id="element-271">
                  <span className="text-2xl" data-id="element-272">{tomo.icon}</span>
                  <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-273">
                    {tomo.title}
                  </h3>
                </div>
                <ChevronDown className={`w-6 h-6 text-orange-500 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-274" />
              </button>

              <AnimatePresence data-id="element-275">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-276">
                    <div className="px-6 pb-5 pt-2 border-t border-gray-800" data-id="element-277">
                      <p className="text-gray-300 text-lg leading-relaxed" data-id="element-278">
                        {tomo.desc}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gray-900 border border-orange-500/30 rounded-2xl p-6 md:p-8" data-id="element-279">
          <h4 className="text-2xl font-bold text-white text-center mb-6" data-id="element-280">
            Cada tomo incluye:
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-281">
            {features.map((feat, i) => <div key={i} className="flex items-center gap-3" data-id="element-282">
                <CheckCircle2 className="w-6 h-6 text-orange-500 flex-shrink-0" data-id="element-283" />
                <span className="text-gray-200 font-medium text-lg" data-id="element-284">
                  {feat}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
};